import React from 'react';

interface PriceBubbleProps {
  price: string;
  isStill: boolean;
}

const PriceBubble: React.FC<PriceBubbleProps> = ({ price, isStill }) => {
  const positionClass = isStill ? 'left-[-26px]' : 'left-[-31px]';
  
  if (price.toLowerCase() === 'free') {
    const textPositionClass = isStill ? 'left-[-18px]' : 'left-[-23px]';
    return (
      <>
        <div className={`w-24 h-24 ${positionClass} top-0 absolute bg-teal-500 rounded-full`} />
        <div className={`w-20 h-11 ${textPositionClass} top-[32px] absolute text-white text-3xl font-extrabold font-['Montserrat'] leading-none`}>{price}</div>
      </>
    );
  }

  const textPricePositionClass = isStill ? 'left-[-10px]' : 'left-[-15px]';
  return (
    <>
      <div className={`w-24 h-24 ${positionClass} top-0 absolute bg-teal-500 rounded-full`} />
      <div className={`w-16 h-11 ${textPricePositionClass} top-[31px] absolute text-white text-3xl font-extrabold font-['Montserrat'] lowercase leading-none`}>{price}</div>
    </>
  );
};

export default PriceBubble;
